import { render, staticRenderFns } from "./set-sunbed-order-state.modal.vue?vue&type=template&id=14272db4&"
import script from "./set-sunbed-order-state.modal.vue?vue&type=script&lang=ts&"
export * from "./set-sunbed-order-state.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports